<template>
    <!-- @todo deal with focus -->
    <!-- @todo do we need to deal with properties being pushed off the screen (vertically)? -->
    <div class="product_options-lists-wrap">

        <div class="product_options-list-wrap">
            <h4 class="product_options-heading">{{ properties[0].shortName }}</h4>
            <ul class="product_options-list">
                <li v-for="variant in variants"
                    class="product_options-list_item">
                    <a href=""
                       @click.prevent="openPrimaryProperty(variant)"
                       :class="{ 'product_options-link-selected' : primaryProperty === variant }"
                       class="product_options-link">
                        <div v-if="variant.thumb"
                             class="product_variant-image-wrap">
                            <span :style="{ 'background-image': 'url('+variant.thumb+')' }"
                                  class="product-variant"></span>
                            {{ variant.value }}
                        </div>
                        <span v-else class="product_variant-value">{{ variant.value }}</span>
                        <svg class="icon-arrow icon-arrow-hidden">
                            <use xlink:href="#arrow"></use>
                        </svg>
                    </a>

                    <div v-if="hasSecondProperty && stacked && primaryProperty === variant">
                        <h4 class="product_options-heading">{{ properties[1].shortName }}</h4>
                        <ul class="product_options-list product_options-sublist product_options-list-secondary">
                            <li v-for="_sp in variant.options"
                                class="product_options-list_item">
                                <a href=""
                                   @click.prevent="openSecondaryProperty(_sp)"
                                   :class="{ 'product_options-link-selected' : secondaryProperty === _sp }"
                                   class="product_options-link">
                                    <div v-if="_sp.thumb"
                                         class="product_variant-image-wrap">
                                        <span :style="{ 'background-image': 'url('+_sp.thumb+')' }"
                                              class="product-variant"></span>
                                        {{ _sp.value }}
                                    </div>
                                    <span v-else>{{ _sp.value }}</span>
                                    <svg class="icon-arrow icon-arrow-hidden">
                                        <use xlink:href="#arrow"></use>
                                    </svg>
                                </a>

                                <variant-details v-if="showDetailsStacked(variant, _sp)"
                                        :product-id="productId"
                                        :product-variant-id="variantId"
                                        :product-name="productName"
                                        :sold-per="soldPer"
                                        :properties="properties"
                                        :primary-property="primaryProperty"
                                        :secondary-property="_sp"
                                        :bulk-quantity="resolvedBulkQuantity"
                                        :full-unit-quantity="resolvedFullUnitQuantity"
                                        :separate-order-product="separateOrderProduct"
                                        :minimum-quantity="minimumQuantity" />
                            </li>
                        </ul>
                    </div>

                    <variant-details
                            v-if="!hasSecondProperty && stacked && showDetailsStacked(variant)"
                            :product-id="productId"
                            :product-variant-id="variantId"
                            :product-name="productName"
                            :sold-per="soldPer"
                            :properties="properties"
                            :primary-property="primaryProperty"
                            :bulk-quantity="resolvedBulkQuantity"
                            :full-unit-quantity="resolvedFullUnitQuantity"
                            :separate-order-product="separateOrderProduct"
                            :minimum-quantity="minimumQuantity" />
                </li>
            </ul>
        </div>

        <div v-if="hasSecondProperty && !stacked" class="product_options-list-wrap">
            <h4 class="product_options-heading">{{ properties[1].shortName }}</h4>
            <div v-if="!primaryProperty" class="product_options-instructions">
                Select a {{ properties[0].shortName }} to see the available {{ properties[1].shortName }}s.
            </div>

            <ul v-if="primaryProperty" class="product_options-list">
                <li v-for="variant in secondaryPropertyValues"
                    class="product_options-list_item">
                    <a href=""
                       @click.prevent="openSecondaryProperty(variant)"
                       :class="{ 'product_options-link-selected' : secondaryProperty === variant }"
                       class="product_options-link">
                        <div v-if="variant.thumb"
                             class="product_variant-image-wrap" >
                            <span :style="{ 'background-image': 'url('+variant.thumb+')' }"
                                  class="product-variant"></span>
                            {{ variant.value }}
                        </div>
                        <span v-else>{{ variant.value }}</span>
                        <svg class="icon-arrow icon-arrow-hidden">
                            <use xlink:href="#arrow"></use>
                        </svg>
                    </a>
                </li>
            </ul>
        </div>

        <variant-details v-if="!stacked && showDetails"
                :product-id="productId"
                :product-variant-id="variantId"
                :product-name="productName"
                :sold-per="soldPer"
                :properties="properties"
                :primary-property="primaryProperty"
                :secondary-property="secondaryProperty"
                :bulk-quantity="resolvedBulkQuantity"
                :full-unit-quantity="resolvedFullUnitQuantity"
                :separate-order-product="separateOrderProduct"
                :minimum-quantity="minimumQuantity" />
    </div>
</template>

<script>
import variantDetails from './variant_details';
import debounce from 'lodash/debounce';
import sortBy from 'lodash/sortBy';

export default {
    props: {
        productId: {
            type: Number,
            required: true,
        },
        productName: {
            type: String,
            required: true,
        },
        soldPer: {
            type: String,
        },
        properties: {
            type: Array,
            required: true,
        },
        variants: {
            type: Array,
            required: true,
        },
        bulkQuantity: {
            type: Number,
        },
        fullUnitQuantity: {
            type: Number,
        },
        separateOrderProduct: {
            type: Boolean,
            required: true,
        },
        minimumQuantity: {
            type: Number,
            default: 0,
        },
    },

    data () {
        return {
            primaryProperty: null,
            secondaryProperty: null,
            secondaryPropertyValues: [],
            hasSecondProperty: this.properties.length > 1,
            windowWidth: null,
            stackedMaxWidth: 64 * 16 + 25, // 64em
        };
    },

    components: {
        variantDetails,
    },

    created () {
        sortBy(this.variants, (p) => {
            return p.sortOrder;
        });

        this.variants.forEach((p) => {
            sortBy(p.options, (_p) => {
                return _p.sortOrder;
            });
        });
    },

    mounted () {
        this.windowResize();
        window.addEventListener('resize', this.windowResize);
    },

    computed: {
        stacked () {
            return (this.windowWidth < this.stackedMaxWidth);
        },
        showDetails () {
            if (this.hasSecondProperty) {
                return null !== this.primaryProperty && null !== this.secondaryProperty;
            } else {
                return null !== this.primaryProperty;
            }
        },

        variantId () {
            if (this.secondaryProperty) {
                return this.secondaryProperty.id;
            } else if (this.primaryProperty) {
                return this.primaryProperty.id;
            }

            return null;
        },
        resolvedBulkQuantity () {
            if (!this.variantId) {
                return this.bulkQuantity;
            }

            if (this.secondaryProperty) {
                return this.secondaryProperty.bulkQuantity || this.bulkQuantity;
            }

            return this.primaryProperty.bulkQuantity || this.bulkQuantity;
        },
        resolvedFullUnitQuantity () {
            if (!this.variantId) {
                return this.fullUnitQuantity;
            }

            if (this.secondaryProperty) {
                return this.secondaryProperty.fullUnitQuantity || this.fullUnitQuantity;
            }

            return this.primaryProperty.fullUnitQuantity || this.fullUnitQuantity;
        },

        hasBulkPricing () {
            return null !== this.bulkQuantity;
        },
        hasFullUnitPricing () {
            return null !== this.bulkQuantity;
        },
    },

    methods: {
        openPrimaryProperty (variant) {
            if (this.primaryProperty === variant) {
                this.primaryProperty = null;
                this.secondaryProperty = null;
                this.secondaryPropertyValues = [];
            } else {
                this.primaryProperty = variant;
                this.secondaryProperty = null;
                this.secondaryPropertyValues = variant.options;
            }
        },
        openSecondaryProperty (variant) {
            if (this.secondaryProperty === variant) {
                this.secondaryProperty = null;
            } else {
                this.secondaryProperty = variant;
            }
        },

        showDetailsStacked (variant, secondaryProperty) {
            if (this.hasSecondProperty) {
                return this.primaryProperty === variant && this.secondaryProperty === secondaryProperty;
            } else {
                return this.primaryProperty === variant;
            }
        },

        windowResize: debounce(function () {
            const e = document.documentElement,
                g = document.body;

            this.windowWidth = window.innerWidth || e.clientWidth || g.clientWidth;
        }, 500),
    },
}
</script>
